import { render, staticRenderFns } from "./AuthByToken.vue?vue&type=template&id=89584b4c&scoped=true"
import script from "./AuthByToken.vue?vue&type=script&lang=js"
export * from "./AuthByToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89584b4c",
  null
  
)

export default component.exports